export const ERROR_MESSAGES = {
	'gg': {
	  title: '4-0-Fore!',
	  message: 'We\'re sorry, the page you are looking for cannot be found. Try heading back to the home page.',
	  link: 'https://www.golfgalaxy.com',
	  linkText: 'GO BACK HOME'
	},
	'pl': {
	  title: 'You\'re off the map',
	  message: 'This page is unavailable. Let\'s get you back on the trail.',
	  link: 'https://www.publiclands.com',
	  linkText: 'GO BACK HOME'
	},
	'dsg': {
	  title: 'Error on the play',
	  message: 'This page is not available.',
	  link: 'https://www.dickssportinggoods.com',
	  linkText: 'GO BACK HOME'
	},
	'g3': {
	  title: 'No Scores Here',
	  message: 'Going, Going...you\'ve gone too far. Let\'s get you back in the game.',
	  link: 'https://www.goinggoinggone.com',
	  linkText: 'GO BACK HOME'
	},
	'mj': {
		title: 'You\'re off the map',
		message: 'This page is unavailable. Let\'s get you back on the trail.',
		link: 'https://www.moosejaw.com',
		linkText: 'GO BACK HOME'
	}
};
